/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_TypeInputs */

const en_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document type`)
};

const es_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de documento`)
};

const fr_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de document`)
};

const de_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenttyp`)
};

const ja_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書類の種類`)
};

const zh_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`证件类型`)
};

const ar_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الوثيقة`)
};

const id_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis dokumen`)
};

const it_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di documento`)
};

const ru_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип документа`)
};

const pt_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de documento`)
};

const ko_document_type = /** @type {(inputs: Document_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 유형`)
};

/**
* | output |
* | --- |
* | "Document type" |
*
* @param {Document_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_type = /** @type {((inputs?: Document_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_type(inputs)
	if (locale === "es") return es_document_type(inputs)
	if (locale === "fr") return fr_document_type(inputs)
	if (locale === "de") return de_document_type(inputs)
	if (locale === "ja") return ja_document_type(inputs)
	if (locale === "zh") return zh_document_type(inputs)
	if (locale === "ar") return ar_document_type(inputs)
	if (locale === "id") return id_document_type(inputs)
	if (locale === "it") return it_document_type(inputs)
	if (locale === "ru") return ru_document_type(inputs)
	if (locale === "pt") return pt_document_type(inputs)
	return ko_document_type(inputs)
});